import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import './chat.scss'

const Join = () => {
  const [name, setName] = useState('')
  const [room, setRoom] = useState('')
  
  return (
    <form className = "dcontainer my-5" >
      <h2>Join</h2>
  <div className="mb-3">
    <label className="form-label">Name</label>
    <input type="text" className="form-control" aria-describedby="emailHelp" onChange = {(event) => setName(event.target.value)}/>
   
  </div>
  <div className="mb-3">
    <label  className="form-label">Room</label>
    <input type="text" className="form-control" onChange = {(event) => setRoom(event.target.value)}/>
  </div>
  <Link  to = {name !== '' && room !== '' ? `/chat?name=${name}&room=${room}` : "/"}> <button type="submit" className="btn btn-primary">Submit</button></Link>
</form>
  )
}

export default Join 